import { TileMenuItem } from "@/api/dtos";
import Icon from "@/components/layouts/Icon/Icon";
import { ITrial } from "@/components/TrialsArea";
import { faChevronDown, faChevronUp, faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { Box, ButtonBase, darken, Divider, lighten, ListItemText, styled, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { InformationIcon, StyledList, StyledListItemButton, StyledListItemIcon, StyledListItemInformationIcon, StyledListItemText } from "..";
import RecursiveMenuItem from "./RecursiveMenuItem";



const AppearingButton = styled(ButtonBase)(({ theme }) => ({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    borderRadius: '50%',
    background: theme.palette.mode === 'dark' ? darken(theme.palette.primary.main,0.5) : lighten(theme.palette.primary.main, 0.5),

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2rem',
    opacity: 0,
    transition: 'opacity 0.5s linear',
}));

const ExpandButtonBox = styled(Box)(() => ({
    width: '22.5px',
    height: '22.5px',
    flex: '0 0 auto',
    alignSelf: 'center',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    userSelect: 'none',
}));

interface IExpandableMenuItemProps {
    tileMenuItem: TileMenuItem;
    trial: ITrial;
    tileData?: Record<string, string>;
    expandedMenuItemsNonFav?: Record<number, boolean> | undefined;
    toggleExpandedMenuItem?: (trialId: number, expandMenuItemId: number) => void | undefined;
    toggleExpandedMenuItemNonfav?: (expandMenuItemId: number) => void | undefined;
}

const ExpandableMenuItem: FC<IExpandableMenuItemProps> = ({
    tileMenuItem, 
    trial,
    tileData,
    expandedMenuItemsNonFav,
    toggleExpandedMenuItemNonfav,
    toggleExpandedMenuItem
}) => {

    // load the hook for the data getting pulled by passing API link

    const expanded = ((tileMenuItem?.expandStateMenuItemId && 
        trial?.expandedMenuItemStates && 
        trial?.expandedMenuItemStates[tileMenuItem?.expandStateMenuItemId] === true) || 
        (expandedMenuItemsNonFav &&
        tileMenuItem.expandStateMenuItemId &&
        expandedMenuItemsNonFav[tileMenuItem.expandStateMenuItemId] === true)
    )

    return (
        <>
            <StyledListItemButton
                onClick={() => {(toggleExpandedMenuItem && tileMenuItem.expandStateMenuItemId) ? 
                        toggleExpandedMenuItem(trial.id, tileMenuItem.expandStateMenuItemId) 
                    : 
                    toggleExpandedMenuItemNonfav && tileMenuItem.expandStateMenuItemId &&
                    toggleExpandedMenuItemNonfav(tileMenuItem.expandStateMenuItemId)}}
            >
                <StyledListItemIcon>
                    <Icon icon={{ prefix: tileMenuItem.iconPrefix as any, iconName: tileMenuItem.iconName as any }} size="lg" fixedWidth />
                </StyledListItemIcon>
                
                {
                    tileMenuItem.tooltipInformations && tileMenuItem.tooltipInformations.length > 0 ? (
                        <>
                            <StyledListItemText 
                                primary={tileMenuItem.name}
                            />
                            <StyledListItemInformationIcon>
                                <Tooltip title={tileMenuItem.tooltipInformations.map(
                                    (tooltipInformation, i, entireList) => (
                                        <div key={i}>
                                            <Typography variant="h3">
                                                {tooltipInformation.heading}
                                            </Typography>
                                            <Typography variant="body1">
                                                {tooltipInformation.content}
                                            </Typography>
                                            {
                                                (i < (entireList.length - 1)) && <br />
                                            }
                                        </div>
                                    )
                                )}>
                                    <InformationIcon icon={faCircleInfo} size="lg" fixedWidth />
                                </Tooltip>
                            </StyledListItemInformationIcon>
                        </>
                    ) : (
                        <ListItemText 
                            primary={tileMenuItem.name}
                        />
                    )
                }
                <ExpandButtonBox>
                    <AppearingButton
                        // onClick={toggle} // This is not needed as the parent has the onClick event
                        className="expandIcon"
                    >
                        <Icon fixedWidth icon={expanded ? faChevronUp : faChevronDown } size='2xs'/>
                    </AppearingButton>
                    <Icon fixedWidth icon={expanded ? faChevronUp : faChevronDown } size='lg'/>
                </ExpandButtonBox>
            </StyledListItemButton>
            {
                expanded && (
                    <>
                        <Divider />
                            {
                                !!tileMenuItem.subTileMenuItems && (
                                    
                                    <StyledList
                                        disablePadding
                                    >
                                        {
                                
                                            tileMenuItem.subTileMenuItems.map((menuItem, i, entireList ) => (
                                                <RecursiveMenuItem 
                                                    key={`ExpandableMenuItem-${i}`} 
                                                    menuItem={menuItem} 
                                                    finalInList={(i === entireList.length-1)} 
                                                    finalComponent={false}
                                                    trial={trial}
                                                    tileData={tileData}
                                                    toggleExpandedMenuItem={toggleExpandedMenuItem}
                                                    toggleExpandedMenuItemNonfav={toggleExpandedMenuItemNonfav}
                                                    expandedMenuItemsNonFav={expandedMenuItemsNonFav}
                                                />
                                            ))
                                        }
                                    </StyledList>
                                )
                            }
                    </>
                )
            }
        </>
    )
}

export default ExpandableMenuItem;